import axios from "axios";
import { _sendWithAxios, _paramsWithAxios } from "../api";
import globals from "../../globlas";

export const listarAtividadesRecentes = async (pagina, tamanho) => {
  return await _sendWithAxios(
    `${globals.REACT_APP_URL_BASE_API}AtividadeRecente/lista-atividades-recentes/${tamanho}/${pagina}`,
    "GET"
  );
};

export const exportarRelatorioAtividadesRecentes = async (ano, mes, data) => {
  return await axios.get(
    `${globals.REACT_APP_URL_BASE_API}AtividadeRecente/relatorio-atividades-recentes`,
    {
      params: { ano, mes, data },
      responseType: "blob",
    }
  );
};
